import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import type { ITariffBreakdownModalProps } from '../../types/propTypes';

const TariffBreakdownModal = ({ showModal, onHide, type, priceBreakdown, unit }: ITariffBreakdownModalProps) => {
    const isDesktop = useMediaQuery({ query: `(min-width: 768px)` });

    const { t } = useTranslation();

    const TariffBreakdownMessage = {
        Energy: t('stationDetails.tariffDetailsModal.breakdownMessage.energy'),
        Flat: t('stationDetails.tariffDetailsModal.breakdownMessage.flat'),
        Parking: t('stationDetails.tariffDetailsModal.breakdownMessage.parking'),
        Overstay: t('stationDetails.tariffDetailsModal.breakdownMessage.overstay'),
        Time: t('stationDetails.tariffDetailsModal.breakdownMessage.time'),
    };

    return (
        <Modal
            size="sm"
            show={showModal}
            onHide={onHide}
            style={isDesktop ? { marginTop: '78px' } : {}}
            centered={!isDesktop}
            className="px-3"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <div className="breakdown-fee" style={{ color: '#1a1a1a' }}>
                        {type} {t<string>('stationDetails.tariffDetailsModal.fee')}
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="pt-0">
                <div className="pb-4 fs-6">{TariffBreakdownMessage[type]}</div>

                <ul className="pb-3 tariff-scroll-list">
                    {priceBreakdown &&
                        priceBreakdown.length > 0 &&
                        priceBreakdown
                            .sort((a, b) => a.position - b.position)
                            .map((price, index) => (
                                <li key={index} className="pb-2">
                                    {price.kwh_label && price.duration_label
                                        ? `${price.kwh_label} ${t<string>(
                                              'stationDetails.tariffDetailsModal.and',
                                          )} ${price.duration_label}`
                                        : price.kwh_label || price.duration_label || null}{' '}
                                    -{' '}
                                    <span
                                        style={{
                                            fontWeight: '900',
                                            letterSpacing: '0.3px',
                                        }}
                                    >
                                        {price.price}
                                    </span>
                                    {unit ? ` / ${unit}` : null}
                                </li>
                            ))}
                </ul>
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
        </Modal>
    );
};

export default TariffBreakdownModal;
